<template >
  <div class="new-life">
    <my-scroll class="scroll">
      <div class="scroll-content">
        <header>GoLaos用户注销说明</header>
        <h3>一、账号注销方式</h3>
        <div class="letter">
          <span>用户可在 App 内自行完成账号注销操作，具体路径如下：</span><br />
          <span>打开 GoLaos App → 我的 → 设置 → 注销账号</span>"。
        </div>
        <h3>二、注销生效说明</h3>
        <div class="letter1 letter">
          <span>账号注销提交并确认后，将立即或在合理时间内生效。一旦账号被注销，将无法恢复，请您谨慎操作。</span>
        </div>
        <h3>三、数据删除与保留说明</h3>
        <div class="letter letter1">
          <span>账号注销后，我们将删除与该账号相关的个人信息，包括但不限于：</span>
          <ul>
            <li>账号信息</li>
            <li>个人资料</li>
            <li>登录凭证</li>
          </ul>
        </div>
        <div class="letter letter1">
          <span>在符合法律法规及监管要求的前提下，部分数据（如交易记录、财务记录等）可能会被保留一段合理期限，用于合规、审计或纠纷处理，期满后将安全删除。</span>
        </div>
        <h3>四、注销后的影响</h3>
        <div class="letter1 letter">
          <span>账号注销后，您将无法再次使用该账号登录，也无法访问或恢复任何历史数据。</span>
        </div>
      </div>
    </my-scroll>
  </div>
</template>

<script>
import MyScroll from "../../components/MyScroll";
export default {
  name: "newLifeZh",
  components: {
    MyScroll,
  },
  // eslint-disable-next-line space-before-function-paren
  setup() {
    // const { ctx } = getCurrentInstance()
    // console.log(ctx.$root.$route.query.lang)
    return {
      txt1: "",
    };
  },
};
</script>

<style scoped lang="scss">
@mixin flex-box-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-life {
  width: 100%;
  .scroll {
    width: 100%;
    height: 100%;
    padding: 0px 16px;
    position: absolute;
    touch-action: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0px;
    }
    header {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 35px;
      height: 28px;
      padding: 0px 16px;
      overflow: hidden;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      @include flex-box-center;
    }
    .scroll-content {
      position: absolute;
      top: 0px;
      padding: 0px 16px;
      left: 0px;
      h3 {
        padding: 13px 0px 0px;
        margin-bottom: 12px;
        // height: 25px;
        opacity: 1;
        font-size: 15px;
        font-weight: bold;
        text-align: left;
        color: #333333;
        // line-height: 40px;
      }
      span {
        // font-weight: 600;
      }
      .letter {
        text-align: left;
        opacity: 1;
        font-size: 15px;
        font-weight: 400;
        line-height: 25px;
        white-space: normal;
        color: #333333;
      }
      .letter1 {
        margin-top: 12px;
      }
    }
  }
}
</style>
